<template>
  <div>
    <FITModal ref="deleteProviderModal" reference="modal" :title="$t('osm.provider.delete.header')" @click="onClickModalDelete">
      <div slot="body">
        <span v-html="$t('osm.provider.delete.confirmDelete', {providerCode: form.providerCode, providerChineseName: form.providerChineseName, providerEnglishName: form.providerEnglishName})"></span>
      </div>
    </FITModal>
    <b-row align-h="center" class="mt-0 pt-0">
      <div class="w-75">
        <FITFormCard>
          <div slot="header">
            <b-row align-v="center">
              <b-col cols="6">
                <h4>{{header}}</h4></b-col>
              <b-col cols="auto" class="ml-auto" v-if="detail">
                <FITButton size="md" :text="$t('general.CURD.delete')" variant="danger" @click="onClickDelete"></FITButton>
              </b-col>
            </b-row>
          </div>
          <div slot="formBody">
            <div>
              <FITTextInput field="providerCode" :label="$t('osm.provider.providerCode')" :width="8" v-model="form.providerCode"></FITTextInput>
              <FITTextInput field="providerEnglishName" :label="$t('osm.provider.create.providerEnglishName')" :width="8" v-model="form.providerEnglishName"></FITTextInput>
              <FITTextInput field="providerChineseName" :label="$t('osm.provider.create.providerChineseName')" :width="8" v-model="form.providerChineseName"></FITTextInput>
              <FITTextarea field="providerDescription" :label="$t('osm.provider.create.providerDescription')" :width="8" v-model="form.providerDescription"></FITTextarea>
              <FITTextInput field="providerCountry" :label="$t('osm.provider.create.providerCountry')" :width="8" v-model="form.providerCountry"></FITTextInput>
              <!-- HT -->
              <FITTextarea field="mailingAddress" :label="$t('osm.provider.create.mailingAddress')" :width="8" v-model="form.mailingAddress"></FITTextarea>
              <FITTextInput field="relationshipManager" :label="$t('osm.provider.create.relationshipManager')" :width="8" v-model="form.relationshipManager"></FITTextInput>
              <FITTextInput field="contactNumber" :label="$t('osm.provider.create.contactNumber')" :width="8" v-model="form.contactNumber"></FITTextInput>
              <FITTextInput field="brokerHotline" :label="$t('osm.provider.create.brokerHotline')" :width="8" v-model="form.brokerHotline"></FITTextInput>
              <FITTextInput v-if="!this.detail" field="splitRate" :label="$t('osm.provider.create.splitRate')" :width="8" v-model="form.splitRate"></FITTextInput>
              <FITTextInput v-if="!this.detail" field="splitRate2" :label="$t('osm.provider.create.splitRate2')" :width="8" v-model="form.splitRate2"></FITTextInput>
            </div>
            <b-row>
              <b-col class="text-right">
                <FITButton size="md" :text="$t('general.submit')" variant="primary" @click="validationCheck"></FITButton>
              </b-col>
            </b-row>
          </div>
        </FITFormCard>
      </div>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import { FITFormCard, FITTextInput, FITTextarea, FITButton, FITModal } from '@/components'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'ProviderCreate',
  components: {
    FITFormCard,
    FITTextInput,
    FITTextarea,
    FITButton,
    FITModal
  },
  created() {
    // Get Validation Rule
    let validationType = 'create'
    if (this.detail) {
      validationType = 'edit';
    }
    this.$store.commit('Validation/validationReset');
    this.$store.dispatch('Validation/getValidationRule', `/provider/${validationType}`);
    this.$store.commit('Validation/setAlertMsg', { alertMsg: this.$t("validation.alertMsg.error") });

    if (this.detail) {
      Vue.set(this, 'form', this.detail);
      Vue.set(this.form, 'splitRate', this.convertFloatToPercent(this.detail.splitRate));
      Vue.set(this.form, 'splitRate2', this.convertFloatToPercent(this.detail.splitRate2));
    }
  },
  methods: {
    submit() {
      let action = 'Provider/createProvider'
      if (this.form.ID) {
        action = 'Provider/editProvider';
      }

      var data = JSON.parse(JSON.stringify(this.form));
      if (!this.detail) {
        data['splitRate'] = this.convertPercentToFloat(this.form.splitRate);
        data['splitRate2'] = this.convertPercentToFloat(this.form.splitRate2);
      } else {
        delete data['splitRate'];
        delete data['splitRate2'];
      }
      this.$store.dispatch(action, data).then((json) => {
        this.$router.replace({ name: 'Provider List', params: { alertContent: this.$t('general.updateSuccess'), alertVariant: 'success' } });
      }).catch((error) => {
        console.debug(error);
      })
    },
    convertFloatToPercent(input) {
      var ans = (parseFloat(input) * 100).toFixed(2);
      return isNaN(ans) ? "" : ans;
    },
    convertPercentToFloat(input) {
      var ans = (input / 100).toFixed(2);
      return isNaN(ans) ? "" : ans;
    },
    validationCheck() {
      this.$store.dispatch('Validation/validationCheckBeforeSubmit');
      return;
    },

    onClickModalDelete(event) {
      if (!event) {
        return;
      }
      this.$store.dispatch('Provider/deleteProvider', this.form.ID).then((json) => {
        this.$refs.deleteProviderModal.closeModal();
        this.$router.replace({
          name: 'Provider List',
          params: { alertContent: this.$t('general.deleteSuccess'), alertVariant: 'success' }
        })
      })
    },
    onClickDelete() {
      this.$refs.deleteProviderModal.openModal();
    }
  },
  props: {
    providerHeader: {
      type: String,
      default: null,
    },
    detail: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      'vuexFinalResult': state => state.Validation.validationFinalResult,
    }),

    header() {
      if (this.providerHeader) {
        return this.providerHeader;
      }
      return this.$t('osm.provider.create.header');
    }
  },
  watch: {
    vuexFinalResult(newData, oldData) {
      let result = newData;
      // console.log("Final Result: "+newData);
      if (result) {
        this.submit();
        this.$store.commit('Validation/validationReset');
        // FITValidationBus.$emit('reset', true);
      }
    }
  },
  data() {
    return {
      form: {
        providerCode: '',
        providerEnglishName: '',
        providerChineseName: '',
        providerDescription: '',
        providerCountry: '',
        mailingAddress: '',
        relationshipManager: '',
        contactNumber: '',
        brokerHotline: '',
        splitRate: '',
        splitRate2: '',
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/Provider/containers/ProviderCreate.vue